var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.list),function(juego,index){return _c('v-card',{key:`juego-${juego.id}-${index}`},[_c('v-card-title',[_vm._v(" "+_vm._s(juego.name)+" ")]),_c('v-card-actions',[_c('v-expansion-panels',{attrs:{"flat":""}},[_c('v-expansion-panel',[_c('v-expansion-panel-header',[_vm._v("Divisas")]),_c('v-expansion-panel-content',[_c('CupoCrud',{attrs:{"context":"taquilla","divisaList":juego.availableDivisaList,"owner":{
                    taquilla_id: _vm.taquilla.id,
                    juego_id: juego.id,
                },"has-limit":""}})],1)],1)],1)],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }